import { render, staticRenderFns } from "./reportsettings.vue?vue&type=template&id=845ab522&scoped=true"
import script from "./reportsettings.vue?vue&type=script&lang=js"
export * from "./reportsettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "845ab522",
  null
  
)

export default component.exports